import { FC, useContext } from "react";

import { finishedProcessTypes, RydeProcessTitle } from "@ryde/shared";

import { ProcessDrawerContext } from "../process-drawer-context";
import { ProcessStatisticBackupCreate } from "./process-statistic-backup-create";
import { ProcessStatisticBackupRestore } from "./process-statistic-backup-restore";
import { ProcessStatisticGeneric } from "./process-statistic-generic";

export const ProcessStatisticStrategy: FC = () => {
  const { currentProcess } = useContext(ProcessDrawerContext);

  if (
    !currentProcess ||
    !finishedProcessTypes.includes(currentProcess?.status)
  ) {
    return null;
  }

  if (currentProcess.title === RydeProcessTitle.BackupRestore) {
    return <ProcessStatisticBackupRestore />;
  }

  if (currentProcess.title === RydeProcessTitle.BackupCreate) {
    return <ProcessStatisticBackupCreate />;
  }

  return <ProcessStatisticGeneric />;
};
